import NumberFormattingService from 'client/services/number-formatting-service';

const NotEqualsZeroMethodValidationMethod = {
  name: 'notEqualsZero',
  validateValue: value => NumberFormattingService.coerceOtherTypesToNumber(value) !== 0,
};

export default NotEqualsZeroMethodValidationMethod;
